import batchComponent from './batch.component';
import BatchCreate from './create'
import BatchEdit from './edit'
import BatchAll from './all'

let batchModule = angular.module('batch', [
    BatchCreate,
    BatchEdit,
    BatchAll
  ])

  .component('batch', batchComponent)

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
      .state('batch.edit', {
        url: '/edit/:id',
        component: 'batchedit'
      })

      .state('batch.create', {
        url: '/create',
        component: 'batchcreate'
      })

      .state('batch.all', {
        url: '/all/:page',
        component: 'batchall',
      })
  })

  .name;

export default batchModule;


// WEBPACK FOOTER //
// ./client/app/components/batch/index.js